import { defineComponent as _defineComponent } from 'vue'
import { Notification } from 'ah-api-gateways';
import NotificationCard from './NotificationCard.vue';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { useNotificationsStore } from 'ah-notifications/src/store';
import { useServices } from 'bd-common/src/services';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationsList',
  props: {
    maxItems: { default: 0 },
    notifications: null
  },
  emits: ["marked-as-read"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'marked-as-read', notification: Notification): void;
}), expose: any, slots: any, attrs: any }) {





const notificationsStore = useNotificationsStore();

const services = useServices();

const requestManager = useRequestManager({
  exposeToParent: true,
});

function onFileDownload(item: Notification) {
  requestManager.manager
    .currentOrNew(`download-${item.id}`, services.documents.downloadSyncDocument(item.resourceOrigin!, item.resource!))
    .subscribe();
}

function isItemDownloading(item: Notification) {
  return requestManager.manager.requestStates[`download-${item.id}`] === 'pending';
}

function markAsRead(notification: Notification) {
  notificationsStore.markAsRead(notification);
  emit('marked-as-read', notification);
}

return { __sfc: true,emit, notificationsStore, services, requestManager, onFileDownload, isItemDownloading, markAsRead, NotificationCard }
}

})